import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash';
import { useTranslation } from 'react-i18next';
// Import UI Components
import { BusyLoader, Section, Tooltip } from '@geneui/components';
// Import Constants
import { l } from 'constants/common';

const CampaignBonusCountSection = ({ data }) => {
    const { t } = useTranslation();

    const bonusCount =
        isNil(data?.count) && isNil(data?.total) ? t(l.NA) : `${data.count ?? t(l.NA)} / ${data.total ?? t(l.NA)}`;

    return (
        <Section text={t(l.Bonus)}>
            <BusyLoader isBusy={isNil(data)} type="spinner" spinnerSize={'medium'}>
                <div className="bonus-sum-wrap">
                    <p className="title-currency">{`${t(l.Sent)} / ${t(l.Total)}`}</p>
                    <Tooltip text={bonusCount} position="top">
                        <p className="currency-amount">{bonusCount}</p>
                    </Tooltip>
                </div>
            </BusyLoader>
        </Section>
    );
};

CampaignBonusCountSection.propTypes = {
    data: PropTypes.object,
};

export default memo(CampaignBonusCountSection);
